import React from 'react';
import BackButton from './BackButton';

const ViewHeader = ({ title, subtitle, onBack }) => (
    <div className="clinic-dashboard-header">
        {onBack && <BackButton onClick={onBack} />}
        <div className="clinic-dashboard-header-text">
            <h1>{title}</h1>
            <p>{subtitle}</p>
        </div>
    </div>
);

export default ViewHeader;
    